import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { DashboardLayoutComponent } from '../dashboard-layout/dashboard-layout.component';
import { FooterComponent } from '../footer/footer.component';
import { TopNavigationComponent } from '../top-navigation/top-navigation.component';

@Component({
  selector: 'idap-app-layout',
  standalone: true,
  imports: [DashboardLayoutComponent, FooterComponent, RouterOutlet, TopNavigationComponent],
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.scss'
})
export class AppLayoutComponent {}
